import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, Wallet, TrendingUp } from "lucide-react";

export default function Welcome() {
  return (
    <div className="fp-shell fp-grain" data-testid="welcome-screen">
      <div className="relative z-10 px-6 pt-16 pb-10 min-h-screen flex flex-col">
        {/* Brand */}
        <div className="mb-12 animate-fade-up">
          <img
            src="/branding/logo-horizontal-400.png"
            srcSet="/branding/logo-horizontal-400.png 1x, /branding/logo-horizontal-800.png 2x"
            alt="FiPer"
            width="124"
            height="70"
            className="h-12 w-auto select-none"
            data-testid="welcome-brand-logo"
            draggable="false"
          />
        </div>

        {/* Hero */}
        <div className="flex-1 animate-fade-up">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-sage-700">
            Finanzas personales
          </p>
          <h1 className="mt-3 font-display text-5xl sm:text-6xl font-extrabold tracking-tight leading-[1.02] text-ink">
            Tu dinero real,<br />
            <span className="text-sage-700">sin reinicios.</span>
          </h1>
          <p className="mt-5 text-base text-muted2 leading-relaxed max-w-sm">
            FiPer te muestra cuánto tienes disponible de verdad. El saldo se acumula entre meses, no se borra.
          </p>

          {/* Feature pills */}
          <div className="mt-10 space-y-3">
            <FeatureRow
              icon={Wallet}
              title="Saldo real acumulado"
              desc="Lo que terminaste este mes empieza el siguiente."
            />
            <FeatureRow
              icon={TrendingUp}
              title="Proyecciones simples"
              desc="A 7 días, 15 días y fin de mes."
            />
            <FeatureRow
              icon={Sparkles}
              title="Listo para pareja"
              desc="Modo individual ahora, en pareja muy pronto."
            />
          </div>
        </div>

        {/* CTAs */}
        <div className="mt-10 space-y-3 animate-fade-up">
          <Link
            to="/register"
            data-testid="welcome-register-button"
            className="flex items-center justify-center gap-2 w-full bg-sage-900 text-bone rounded-2xl py-4 font-bold hover:bg-sage-900/90 active:scale-[0.98] transition-all"
          >
            Crear mi cuenta <ArrowRight size={18} />
          </Link>
          <Link
            to="/login"
            data-testid="welcome-login-button"
            className="flex items-center justify-center w-full bg-white border border-line text-ink rounded-2xl py-4 font-bold hover:bg-sage-50 transition-colors"
          >
            Ya tengo cuenta
          </Link>
          <p className="text-center text-xs text-soft mt-4">
            Demo: <span className="font-semibold">demo@fiper.app</span> / <span className="font-semibold">demo123</span>
          </p>
        </div>
      </div>
    </div>
  );
}

function FeatureRow({ icon: Icon, title, desc }) {
  return (
    <div className="flex items-start gap-3 bg-white/60 border border-line/60 rounded-2xl p-4 backdrop-blur-sm">
      <div className="h-10 w-10 rounded-xl bg-sage-50 text-sage-700 flex items-center justify-center shrink-0">
        <Icon size={18} strokeWidth={1.8} />
      </div>
      <div>
        <p className="font-display font-bold text-ink">{title}</p>
        <p className="text-sm text-muted2 leading-snug">{desc}</p>
      </div>
    </div>
  );
}
